import { Injectable } from '@angular/core';
import {
  DefaultPersistenceResultHandler,
  EntityAction,
  EntityCollection,
  EntityCollectionReducerMethodMap,
  EntityCollectionReducerMethods,
  EntityDefinitionService,
} from '@ngrx/data';
import { Action } from '@ngrx/store';

@Injectable()
export class CustomPersistenceResultHandler extends DefaultPersistenceResultHandler {
  override handleSuccess(originalAction: EntityAction): (data: any) => Action {
    const actionHandler = super.handleSuccess(originalAction);
    // return a factory to get a data handler to
    // parse data from DataService and save to action.payload
    return (resp: any) => {
      let action;
      let extra = {};
      switch (originalAction.payload.entityOp) {
        case '@ngrx/data/query-many':
          extra = {
            count: resp.count,
            total: resp.total,
            page: resp.page,
            pageCount: resp.pageCount,
          };
          action = actionHandler(resp?.data ?? resp);
          break;

        default:
          action = actionHandler(resp);
          break;
      }

      if (action && resp && extra) {
        // Save extra in payload
        (action as any).payload.extra = extra;
      }

      return action;
    };
  }
}

export class CustomEntityCollectionReducerMethods<
  T
> extends EntityCollectionReducerMethods<T> {
  // override readonly methods: EntityCollectionReducerMethodMap<T> = {
  //   // ...this.methods,
  //   // setSelectedId: this.setSelectedId.bind(this),
  // };

  protected override queryManySuccess(
    collection: EntityCollection<T>,
    action: EntityAction<T[]>
  ): EntityCollection<T> {
    const ec = super.queryManySuccess(collection, action);
    if ((action.payload as any).extra) {
      // save the extra property from action.payload to entityCollection instance
      (ec as any).extra = (action.payload as any).extra;
    }

    return ec;
  }

  protected override queryAllSuccess(
    collection: EntityCollection<T>,
    action: EntityAction<T[]>
  ): EntityCollection<T> {
    const ec = super.queryAllSuccess(collection, action);

    if ((action.payload as any).extra) {
      // save the extra property from action.payload to entityCollection instance
      (ec as any).extra = (action.payload as any).extra;
    }

    return ec;
  }

  //   protected setSelectedId(
  //     collection: EntityCollection<T>,
  //     action: EntityAction<number>
  //   ): EntityCollection<T> {
  //     return produce(
  //       collection,
  //       (draft: Draft<EntityCollection<T> & { selectedId: number }>) => {
  //         draft.selectedId = action.payload.data;
  //       }
  //     );
  //   }
}

@Injectable()
export class CustomEntityCollectionReducerMethodsFactory {
  constructor(private entityDefinitionService: EntityDefinitionService) {}
  /** Create the  {EntityCollectionReducerMethods} for the named entity type */
  create<T>(entityName: string): EntityCollectionReducerMethodMap<T> {
    const definition =
      this.entityDefinitionService.getDefinition<T>(entityName);

    const methodsClass = new CustomEntityCollectionReducerMethods(
      entityName,
      definition
    );

    return methodsClass.methods;
  }
}
